import namespace from '@/store/namespace'
export default namespace('Ampliacion',{
    getters:[
        'GetAmpliacion',
        'GettipoSolicitudLis',
        'GetdatosAmpliacionesNet'
    ],
    actions:[
        'RegistrarAmpliacion',
        'ModificarAmpliacion',
        'ObtenerAmpliacionModificacion',
        'ObtenerAmpliacion',
        'EnviarSolicitud',
        'ObtieneAmpliacionesNet',
        'ObtenerAmpliacionNetPorPersonaId',
        'ObtieneAmpliacionxAmpliacionId',
        'ObtieneAmpliacionObservadoxTramiteId'
    ],
    mutations:[
        'SetAmpliacion',
        'SettipoSolicitudLis',
        'SetdatosAmpliacionesNet'
    ]
})